import * as tracking from 'dibs-tracking';
import get from 'lodash.get';
import {
    SORT,
    CURRENCY,
    FILTER_REFINE_SEARCH,
} from '../../../finding/SbSharedRefineMenu/sbSharedRefineMenuConstants';

export const trackFilterClick = (filterName, isExpanding) => {
    tracking.trackEvent({
        category: 'results page refinement',
        action: isExpanding ? 'expand facet' : 'collapse facet',
        // category, item type, price, etc
        label: filterName.toLowerCase(),
    });
};

export const trackSeeMoreClick = filterName => {
    tracking.trackEvent({
        category: 'results page refinement',
        action: 'show more options',
        label: `${filterName.toLowerCase()} selected`,
    });
};

export const trackSearchWithinResults = event => {
    tracking.trackEvent(
        {
            category: 'results page refinement',
            action: 'search within results',
        },
        event
    );
};

export const trackFilterChange = ({
    filterName,
    filterValue,
    isFromTypeahead,
    isDeselected,
    triggerType,
    ga = {},
    event = undefined,
    isInteractiveEvent,
}) => {
    // Used in filterActions.updateUriRef, but some filters have unique tracking or no tracking at all
    if (!filterName) {
        return;
    }

    const displayName = get(filterValue, 'displayName');
    const selectedCopy = isDeselected ? 'deselected' : 'selected';
    const filterTrackingBlacklist = [SORT, CURRENCY];

    // categories should be just l2, l3, l4, etc.
    // refineSearch should be refine search
    const trackingFilterName = filterName
        .replace('category', '')
        .replace(FILTER_REFINE_SEARCH, 'refine search')
        .toLowerCase();

    // don't fire filter tracking for blacklisted filters
    if (!filterTrackingBlacklist.includes(filterName)) {
        tracking.trackEvent(
            {
                category: `results page facet ${selectedCopy}`,
                //  This takes the value of the filter heading (except for category which will take (l2, l3, l4)
                action: `${trackingFilterName} ${selectedCopy}`,
                // This takes the value of the selection chosen (ex. paintings, tables, seating, etc...)
                // When choice is selected from the 'see more' modal, eventLabel will also include 'from modal' (ex. eventLabel: gemstone selected from modal)
                label: `${displayName}${isFromTypeahead ? ' from modal' : ''}`,
                additional: {
                    ...(triggerType ? { triggerType } : {}), // only add triggerType if it is truthy
                },
                isInteractiveEvent,
                ...ga,
            },
            event
        );
    }
};
